import { FormType, Formula } from '../../Formula';
export class GenericFormula extends Formula {
    constructor(tree, compiler) {
        super(tree, compiler);
    }
    get form() {
        return FormType.GENERIC;
    }
}
